import type { Point } from '../../state/types';
import { Connector } from '../../shapes/Connector';
import { RECOGNITION_CONFIG } from '../config';
import type { RecognitionResult } from '../types';
import { fitLine } from './line';

export const recognizeConnector = (points: Point[]): RecognitionResult => {
  const { start, end, straightness } = fitLine(points);

  if (straightness > RECOGNITION_CONFIG.lineStraightnessThreshold) {
    const connector = new Connector(
      { x: start.x, y: start.y },
      { x: end.x, y: end.y },
      { endArrow: 'arrow' }
    );

    return {
      type: 'connector',
      confidence: Math.min(straightness, RECOGNITION_CONFIG.lineMaxConfidence),
      shape: connector,
    };
  }

  return { type: 'connector', confidence: RECOGNITION_CONFIG.lineFallbackConfidence };
};
